module.exports = __webpack_public_path__ + "static/img/interest02.87cdb00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/interests_images/interest02.png
// module id = zUct
// module chunks = 0